import React, { useState, useEffect } from "react";
import axios from "axios";
import * as Yup from "yup";

import { Field, Form, Formik } from "formik";
import { useParams, useNavigate, Link } from "react-router-dom";

import Loader from "../../../components/Loader/Loader";

import { toastError, toastSuccess } from "../../../common/Toast";

import config from "../../../config/config";

import Sidebar from "../../Dashboard/Sidebar/Sidebar";

import TimezoneSelect from "react-timezone-select";
import { CUSTOM_SELECT_DROPDOWN_STYLE } from "../../../common/Constant";
import Select from "react-select";

const ManageLocationsNew = (props) => {
  const paramObject = useParams();

  const token = localStorage.getItem("Token");
  const Id = localStorage.getItem("ID");
  const [loading, setLoading] = useState(false);

  //------------------  start from here -------------
  const navigate = useNavigate();
  const [selectedTimezone, setSelectedTimezone] = useState(null);
  const [timezoneError, setTimezoneError] = useState(false);
  const [timeZoneData, setTimeZoneData] = useState([]);

  console.log(timeZoneData, "timeZoneDatatimeZoneData");

  const [formValues, setFormValues] = useState({
    Name: "",
    CompanyName: "",
    Color: "",
    TaxID: "",
    PhoneNumber: "",
    Address: "",
    Fax: "",
    Email: "",
    Timezone: "",
  });

  console.log(formValues, "formValues");

  const validationSchema = Yup.object().shape({
    Name: Yup.string().required("Name is required"),
    Address: Yup.string().required("Address is required"),
    PhoneNumber: Yup.string().required("Phone number is required"),
    Email: Yup.string().email("Invalid email").required("Email is required"),
  });

  const handleSubmit = (values) => {
    if (!selectedTimezone || !selectedTimezone.value) {
      setTimezoneError(true);
      toastError("Timezone is required.");
      return;
    }

    setTimezoneError(false);

    const LocationData = {
      id: paramObject?.id || 0,
      name: values.Name,
      companyname: values.CompanyName,
      color: values.Color,
      taxid: values.TaxID,
      phone: values.PhoneNumber,
      address: values.Address,
      fax: values.Fax,
      email: values.Email,
      // timezone: JSON.stringify(selectedTimezone),
      timezone: selectedTimezone.value,
      loginuserid: Id,
    };

    axios
      .post(`${config.locationBaseUrl}/locations/upsert`, LocationData, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS" && res.data.ResponseID > 0) {
          toastSuccess("Location saved successfully.");
          navigate("/locations");
        } else if (
          res.data.ResponseCode === "ERROR" &&
          res.data.ResponseID === -1
        ) {
          toastError("Email already exists.");
        } else {
          toastError("Something went wrong.");
        }
      })
      .catch(() => {
        toastError("Server error.");
      });
  };

  useEffect(() => {
    if (paramObject.id > 0) {
      setLoading(true);
      axios
        .get(
          `${config.locationBaseUrl}/locations/findbyid?id=${paramObject.id}`,
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              Authorization: token,
            },
          }
        )
        .then((res) => {
          const LocationData = res.data.ResponseData.Locations[0];
          setLoading(false);
          setFormValues(LocationData);
          setSelectedTimezone(LocationData.Timezone ? { value: LocationData.Timezone, label: LocationData.Timezone } : null);
        })
        .catch((err) => {
          setLoading(false);
        });
    }

    axios
      .get(`${config.locationBaseUrl}/locations/gettimezones`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        console.log(res.data.ResponseData, "check timezone dataa");
        let timezoneDropdownOptions = [];
        const timezoneData = res.data.ResponseData.map((u, i) => {
          timezoneDropdownOptions[i] = {
            label: u.Name,
            value: u.Name,
          };
        });
        setTimeZoneData(timezoneDropdownOptions);
      })
      .catch((err) => {
        setLoading(false);
      });
  }, []);

  return (
    <>
      <Sidebar />

      <Loader loading={loading} />

      <div className="page-wrapper cardhead">
        <div className="content container-fluid">
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row breadcrumb-position">
              <ul className="breadcrumb" style={{ marginLeft: "12px" }}>
                <li className="breadcrumb-item">
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/locations">Locations List</Link>
                </li>
                <li className="breadcrumb-item active">Manage Locations</li>
              </ul>
            </div>
          </div>
          <div className="card">
            <div className="card-header">
              <h5 className="card-title">Locations Information</h5>
            </div>
            <Formik
              initialValues={formValues}
              validationSchema={validationSchema}
              onSubmit={handleSubmit}
              enableReinitialize
            >
              {({ errors, touched, handleChange }) => (
                <Form>
                  <div className="card-body">
                    <div className="row mb-2">
                      <div className="col-sm-6">
                        <div className="row">
                          <label className="col-form-label col-md-4 form-label">
                            Name<span className="text-danger">*</span>
                          </label>
                          <div className="col-md-8">
                            <Field
                              type="text"
                              name="Name"
                              className={`form-control form-control-sm ${
                                errors.Name && touched.Name ? "is-invalid" : ""
                              }`}
                              onChange={handleChange}
                            />
                            <div className="invalid-feedback">
                              {touched.Name && errors.Name}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-sm-6">
                        <div className="row">
                          <label className="col-form-label col-md-4 form-label">
                            Company Name
                          </label>
                          <div className="col-md-8">
                            <Field
                              type="text"
                              name="CompanyName"
                              className="form-control form-control-sm"
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row mb-2">
                      <div className="col-sm-6">
                        <div className="row">
                          <label className="col-form-label col-md-4 form-label">
                            Phone Number<span className="text-danger">*</span>
                          </label>
                          <div className="col-md-8">
                            <Field
                              type="text"
                              name="PhoneNumber"
                              className={`form-control form-control-sm ${
                                errors.PhoneNumber && touched.PhoneNumber
                                  ? "is-invalid"
                                  : ""
                              }`}
                              onChange={handleChange}
                            />
                            <div className="invalid-feedback">
                              {touched.PhoneNumber && errors.PhoneNumber}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-sm-6">
                        <div className="row">
                          <label className="col-form-label col-md-4 form-label">
                            Fax
                          </label>
                          <div className="col-md-8">
                            <Field
                              type="text"
                              name="Fax"
                              className="form-control form-control-sm"
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row mb-2">
                      <div className="col-sm-6">
                        <div className="row">
                          <label className="col-form-label col-md-4 form-label">
                            Address<span className="text-danger">*</span>
                          </label>
                          <div className="col-md-8">
                            <Field
                              type="text"
                              name="Address"
                              className={`form-control form-control-sm ${
                                errors.Address && touched.Address
                                  ? "is-invalid"
                                  : ""
                              }`}
                              onChange={handleChange}
                            />
                            <div className="invalid-feedback">
                              {touched.Address && errors.Address}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-sm-6">
                        <div className="row">
                          <label className="col-form-label col-md-4 form-label">
                            Email<span className="text-danger">*</span>
                          </label>
                          <div className="col-md-8">
                            <Field
                              type="email"
                              name="Email"
                              className={`form-control form-control-sm ${
                                errors.Email && touched.Email
                                  ? "is-invalid"
                                  : ""
                              }`}
                              onChange={handleChange}
                            />
                            <div className="invalid-feedback">
                              {touched.Email && errors.Email}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row mb-2">
                      <div className="col-sm-6">
                        <div className="row">
                          <label className="col-form-label col-md-4 form-label">
                            Timezone<span className="text-danger">*</span>
                          </label>
                          <div className="col-md-8">
                            {/* <TimezoneSelect
                              value={selectedTimezone}
                              onChange={(tz) => {
                                setSelectedTimezone(tz);
                                setTimezoneError(false);
                              }}
                            /> */}
                            <Select
                              options={timeZoneData}
                              value={selectedTimezone}
                              onChange={(e) => setSelectedTimezone(e)}
                              isClearable={true}
                              placeholder="Select Timezone"
                              className="w-100"
                              styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                            />
                            {timezoneError && (
                              <div className="text-danger mt-1">
                                Timezone is required.
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className="row">
                          <label className="col-form-label col-md-4 form-label">
                            TaxID
                          </label>
                          <div className="col-md-8">
                            <Field
                              type="text"
                              name="TaxID"
                              className="form-control form-control-sm"
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row mb-2">
                      <div className="col-sm-6">
                        <div className="row">
                          <label className="col-form-label col-md-4 form-label">
                            Color
                          </label>
                          <div className="col-md-8">
                            <Field
                              type="color"
                              name="Color"
                              className={`form-control form-control-sm form-control-color w-2`}
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="mt-3">
                      <button
                        type="submit"
                        className="btn btn-sm btn-primary me-2"
                      >
                        Save
                      </button>
                      <Link
                        to="/locations"
                        className="btn btn-sm btn-secondary"
                      >
                        Cancel
                      </Link>
                    </div>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </div>
    </>
  );
};

export default ManageLocationsNew;
